var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @internal */
export var buildRememberMeComplianceSettings = function (_a) {
    var rememberMe = _a.rememberMe, dpaUri = _a.dpaUri, existingComplianceSettings = _a.existingComplianceSettings;
    if (!rememberMe) {
        return existingComplianceSettings;
    }
    return __assign(__assign({}, existingComplianceSettings), { complianceResources: [
            {
                complianceType: "REMEMBER_ME",
                uri: dpaUri !== null && dpaUri !== void 0 ? dpaUri : window.location.origin,
            },
        ] });
};
